import * as actItem from 'actions/library/item'
import {connect} from 'react-redux'
import ActionBar from './ActionBar'
import List from './List'
import ItemImportModal from './ItemImportModal'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import ItemDetail from './ItemDetail'
import {browserHistory} from 'react-router'
import {isDirty, getFormValues} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import * as mpLibrary from 'mixpanel/library/list'
import './Item.css'

class Item extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      this.props.dispatch(actItem.pageRequest())
      browserHistory.listenBefore(location => {
        if (this.props.isDirtyItem && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {library, loadingSpinner, search} = this.props.data
    let {openRightColumn, showImportModal, items} = library.item
    let {showLoadingSpinnerPage} = loadingSpinner
    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport} />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={items.length === 0}
              title='No Data To Display'
              description='' />
            {!showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <ItemDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ItemImportModal show={showImportModal} dispatch={this.props.dispatch} selectedOutletIds={search ? search.outletIds : []} />
        <ConfirmActionModal />
      </PageWrapper>
    )
  }

  _onClickExport = () => {
    let dataLibrary = this.props.data
    let {library, user} = dataLibrary
    let {item} = library
    let prefix = 'Item Library - '
    mpLibrary.libraryItemExport()
    this.props.dispatch(actItem.itemExportRequest(prefix, user.email, item.outlets))
  }

  _onClickImport = () => {
    this.props.dispatch(actItem.showImportModal())
  }
}

function select (state) {
  // only fetch some state
  return {
    data: {
      library: {
        item: state.library.item
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired,
      search: getFormValues('search')(state)
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyItem: isDirty('item')(state)
  }
}
export default connect(select)(Item)



// WEBPACK FOOTER //
// ./app/pages/Library/Item/Item.js